import React from 'react';
import { Trash2 } from 'lucide-react';

interface AddedLine {
  id: string;
  product_name: string;
  variant_label: string;
  quantity: number;
  promo_free: number;
  promo_paid: number;
  promo_delivered: number;
  distributor_name: string;
  unit_price: number;
  gross_total: number;
  notes?: string;
}

interface AddedOrderLinesProps {
  lines: AddedLine[];
  onRemove: (id: string) => void;
}

const formatMoney = (value: number) => `${value.toFixed(2)} EUR`;

export const AddedOrderLines: React.FC<AddedOrderLinesProps> = ({ lines, onRemove }) => (
  <div className="rounded-xl border border-gray-200 p-4 space-y-3">
    <h3 className="text-sm font-bold text-gray-900">Added lines ({lines.length})</h3>
    {lines.length === 0 ? (
      <p className="text-sm text-gray-500">No lines added yet.</p>
    ) : (
      <div className="space-y-3">
        {lines.map((line) => (
          <div key={line.id} className="border border-gray-200 rounded-lg p-3">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-bold text-gray-900">{line.product_name}</p>
                <p className="text-sm text-gray-600">{line.variant_label}</p>
                <p className="text-xs text-gray-500 mt-1">
                  Qty: {line.quantity}
                  {line.promo_free > 0 && (
                    <>
                      {` (${line.promo_paid} paid + ${line.promo_free} free`}
                      {` = ${line.promo_delivered})`}
                    </>
                  )}
                </p>
                <p className="text-xs text-gray-500">Distributor: {line.distributor_name}</p>
                <p className="text-xs text-gray-500">Unit price: {formatMoney(line.unit_price)}</p>
                <p className="text-sm font-bold text-gray-900 mt-1">
                  Line total: {formatMoney(line.gross_total)}
                </p>
                {line.notes && <p className="text-xs text-gray-500 mt-1">Note: {line.notes}</p>}
              </div>
              <button
                onClick={() => onRemove(line.id)}
                className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                aria-label="Remove line"
              >
                <Trash2 size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);
